import { initializeOpenTelemetryForClient } from "$lib/utilities/opentelemetry";

initializeOpenTelemetryForClient();
